<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">World Record</h1>
    <p class="lead mb-0 text-orange-light">A Milestone of Global Honor</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <h3 class="fw-bold text-success mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-trophy me-2"></i> World Record Gallery
  </h3>

  <div class="row g-3">
    <div class="col-12 col-md-6" *ngFor="let img of recordImages">
      <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
        <img [src]="img" alt="World Record" class="img-fluid w-100" style="object-fit: cover; max-height: 400px;">
      </div>
    </div>
  </div>
</div>
